import { useEffect } from 'react'
import { preloadRoute } from '@/app/routePreload'

/*
 * Starts loading a page's code when a visitor points at, focuses or touches a
 * link to it, so by the time the click lands the route loader has nothing left
 * to wait for and the next page appears at once. Same-site links only; each
 * route loads once and is cached.
 */
export function usePrefetchOnIntent() {
  useEffect(() => {
    const onIntent = (e: Event) => {
      const a = (e.target as Element | null)?.closest?.('a[href]')
      if (!(a instanceof HTMLAnchorElement)) return
      if (a.origin !== window.location.origin || a.target === '_blank') return
      preloadRoute(a.pathname)?.catch(() => {
        /* the route loader retries on click */
      })
    }
    document.addEventListener('pointerover', onIntent, { passive: true })
    document.addEventListener('focusin', onIntent)
    document.addEventListener('touchstart', onIntent, { passive: true })
    return () => {
      document.removeEventListener('pointerover', onIntent)
      document.removeEventListener('focusin', onIntent)
      document.removeEventListener('touchstart', onIntent)
    }
  }, [])
}
